export enum ActionType {
    TC__TL__RELOAD = 'TC__TL__RELOAD',
    TC__TL__TOGGLE_SEARCH = 'TC__TL__TOGGLE_SEARCH',
    TC__TL__FILTER_ITEMS = 'TC__TL__FILTER_ITEMS',
    TC__TL__RECEIVE_ITEMS = 'TC__TL__RECEIVE_ITEMS',
    TC__TL__UPDATE_ITEM = 'TC__TL__UPDATE_ITEM',
    TC__TL__SORT_ITEMS = 'TC__TL__SORT_ITEMS',
    TC__TL__EDIT_ITEM = 'TC__TL__EDIT_ITEM',
    TC__TL__DELETE_ITEM = 'TC__TL__DELETE_ITEM',
    TC__TL__RESET = 'TC__TL__RESET',
}
